import { memo, useMemo } from 'react'
import { useUpdateUserLivePoints } from './use-update-user-live-points'

export const UserLivePoints = memo(() => {
  const { points } = useUpdateUserLivePoints()

  const pointsFormated = useMemo(
    () =>
      Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: 1,
      }).format(points),
    [points],
  )

  const isAndroid = navigator.appVersion.includes('Android')

  return (
    <div
      className=" flex items-center justify-center w-screen
    h-screen"
    >
      <span
        className="text-white font-bold"
        style={{
          fontSize: isAndroid ? '1px' : '10px',
        }}
      >
        {pointsFormated}
      </span>
    </div>
  )
})
